export type ServicePrimaryTag = {
  id: string;
  name: string;
  createdAt: Date;
};

export type CreateServicePrimaryTag = Omit<ServicePrimaryTag, "id">;

export enum ModuleTagType {
  METADATA = "metadataTag",
  SERVICE = "serviceTag",
  THEME = "themeTag",
}

export enum MetadataTagPrimaryType {
  DROPDOWN = "dropdown",
  FREE_INPUT = "free_input",
}

export enum GameTagType {
  SERVICE = "serviceTags",
  THEME = "themeTags",
}
